module.exports = __webpack_public_path__ + "static/media/mum-kids07.b171f9f7.png";